import { render, staticRenderFns } from "./ShowQuestionary.vue?vue&type=template&id=5f6212f2&"
import script from "./ShowQuestionary.vue?vue&type=script&lang=js&"
export * from "./ShowQuestionary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports